// extracted by mini-css-extract-plugin
module.exports = {"block":"SocialNetworks_block__38pzP","title":"SocialNetworks_title__1JyG_","body":"SocialNetworks_body__1RZip"};